import { Component } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { ICurrentUser } from '../../interfaces/user';
@Component({
  selector: 'app-msauth',
  templateUrl: './msauth.component.html',
  styleUrl: './msauth.component.scss'
})
export class MsauthComponent {
  currentUser: ICurrentUser;
  isLoading: boolean = false;
  constructor(private http: HttpClient, private route: ActivatedRoute, private router: Router,) {
    this.IdentityUser = this.initializeUser();
  }

  ngOnInit() {
    localStorage.clear();
    this.isLoading = true;
    this.route.fragment.subscribe(async (fragment: any) => {
      this.isLoading = true;
      let token = (fragment || '').replace('id_token=', '');
      if (token.toString().includes('error=')) {
        this.isLoading = false;
        this.router.navigate(['account/login']);
      }
      else {
        //  console.log(token);
        token = token.replace(/&session_state=[^&]*/, '');
        let accessToken = token;
        localStorage.setItem('token', accessToken);

        //  console.log(accessToken);

        // decode the access token using atob function at set the token value in local storage

        let decodedToken = atob(accessToken.trim().split('.')[1]);
        decodedToken = JSON.parse(decodedToken);
        var customRoles = atob(decodedToken["customRoles"]);
        customRoles = JSON.parse(customRoles);

        this.currentUser.name = customRoles[0]["user_name"];
        this.currentUser.externalId = decodedToken["externalId"];
        this.currentUser.user_id = customRoles[0]["user_id"];
        this.currentUser.status_id = customRoles[0]["status_id"];
        //this.currentUser.role_id = customRoles[0]["role_id"];


        let user_permissions = customRoles[0]["userPermissions"];
        let parsedUserPermissions = JSON.parse(user_permissions);
        this.currentUser.role_id = parsedUserPermissions[0]["role_id"];
        this.currentUser.role_name = parsedUserPermissions[0]["role_name"];
        localStorage.setItem('user_permissions', customRoles[0]["userPermissions"]);
        localStorage.setItem('currentUser', JSON.stringify(this.currentUser));
        // console.log(decodedToken);
       
        if (this.currentUser.role_id == 3) {
          this.router.navigate(['myjob/myjob']);
          this.isLoading = false;
        } else {
          this.router.navigate(['jobs/jobs']);
          this.isLoading = false;
        }

      }

    });
  }

  get IdentityUser(): ICurrentUser {
    return this.currentUser;
  }

  set IdentityUser(user) {
    this.currentUser = user;
  }

  initializeUser(): ICurrentUser {
    return {
      name: '',
      externalId: '',
      user_id: 0,
      status_id: 0,
      role_id: 0,
      role_name: ''
    };
  }
}
